import HeroBasic from '../components/HeroBasic'
import Card from '../components/Card'

function WhyThisMatters() {
    var heroTitle = "Why This Matters"
    var heroSubtitle = "Understanding the decline of environmental enforcement and public transparency."

    var cardHeader = "Public Transparency and Enforcement";

    return (
        <div>
            <HeroBasic title={heroTitle} subtitle={heroSubtitle} />
            <Card header={cardHeader}>
                <p>
                    EPA’s enforcement is trending downward in a significant way since early 2025. The public’s ability to see what compliance issues have been found, but not acted upon, provides concrete examples of where local communities are not getting violations properly addressed through enforcement. 
                </p>

                <p>
                    In some cases, these documents could provide the evidence needed for citizen suits to be developed forcing violations to be corrected, academic research,
                    community organizing, and investigative journalism.
                </p>
            </Card>
        </div>
    )
}

export default WhyThisMatters